require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./study-study-marvellousme-software-development.json") })
        }
      }, "path---study-study-marvellousme-software-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---study-study-marvellousme-software-development!./.cache/json/study-study-marvellousme-software-development.json
// module id = 934
// module chunks = 231608221292675